export default "__VITE_ASSET__CKmlpmwv__"